import getUserTopResults from './getUserTopResults';
import { ComboBoxInputProps } from '../AbstractComboBox/hooks/useComboBoxInput';
import { TopUserResult } from '../AbstractComboBox/types/SuggestResultTypes';
import useSingleSelectComboBox from '../AbstractComboBox/hooks/useSingleSelectComboBox';

export default function useUserSingleSelectComboBox(inputProps: ComboBoxInputProps, initialValue?: TopUserResult) {
  return useSingleSelectComboBox(getUserTopResults, inputProps, initialValue);
}
